import clsx from "clsx";
import { FC } from "react";

export interface ProgressStepperProps {
  steps: number;
  currentStep?: number | null;
  initialPercentage?: number;
  className?: string;
  inverted?: boolean;
}

const ProgressStepper: FC<ProgressStepperProps> = ({
  steps,
  initialPercentage,
  currentStep,
  className,
  inverted,
}) => {
  const isIndeterminate = currentStep === undefined || currentStep === null;
  const resolvedSteps = steps ?? (isIndeterminate ? 1 : currentStep + 1);
  const percentage = isIndeterminate
    ? 0
    : (100 / resolvedSteps) * (currentStep ?? 0);

  const progressStyle: {
    width?: string;
    minWidth?: string;
  } = {};

  if (!isIndeterminate) {
    progressStyle.width = `${percentage}%`;
    if (initialPercentage || initialPercentage === 0) {
      progressStyle.minWidth = `${initialPercentage}%`;
    }
  }

  return (
    <div
      className={clsx("rounded-xs overflow-hidden", className, {
        "bg-neutral-0/30": inverted,
        "bg-neutral-25": !inverted,
      })}
    >
      <div
        className={clsx("h-[6px] rounded-xs", {
          "bg-primary-800": !inverted,
          "bg-primary-100": inverted,
          "duration-500 min-w-[5%] max-w-full transition-all": !isIndeterminate,
          "w-1/3 animate-progress-indeterminate": isIndeterminate,
        })}
        data-testid="progress-bar"
        style={progressStyle}
      />
    </div>
  );
};

export default ProgressStepper;
